import { errorsFactory } from '../../components/utils';

const NoProcessError = errorsFactory('NoProcessError');

export default NoProcessError;
